import './PhotoGallery.scss';

export default function PhotoGallery() {
    return (
        <div className="gallery">
            <img src="iceland.jpg" alt="The Northern Lights in Iceland" className='photo' />
            <img src="vietnam.jpg" alt="A group of people standing with the Vietnam flag in the mountains of Ha Giang, Vietnam" className='photo' />
            <img src="thailand.jpg" alt="Chloe scuba diving in Thailand" className='photo' />
        </div>
    );
}